import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the updated CSS file
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card11 from "../Images/Profiles/Kenneth.jpeg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function KennethArinaitwe() {
  return (
    <div className="ne-page">
      <SEO
        title="Dr. Kenneth Arinaitwe - Chairman, Executive Council"
        description="Dr. Kenneth Arinaitwe is the Chairman, Executive Council at CIRCODU with a PhD in Environmental Analytical Chemistry."
        keywords="Kenneth Arinaitwe, Chairman, Executive Council, CIRCODU, PhD in Environmental Analytical Chemistry"
        url="/kenneth-arinaitwe"
        image={Card11}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Dr. Kenneth Arinaitwe</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/top-management">
              Top Management
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Dr. Kenneth Arinaitwe
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card11} alt="Dr. Kenneth Arinaitwe" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Dr. Kenneth Arinaitwe</h1>
                <p className="profile-card__role">
                  Chairman, Executive Council / Environmental Sciences Expert
                </p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Kenneth is a holder of a Doctor of Philosophy degree conferred
                  by Makerere University, specializing in Environmental
                  Analytical Chemistry. His doctoral research was centered on
                  the comprehensive examination of organic chemical contaminants
                  present in both the atmospheric and aquatic ecosystems of Lake
                  Victoria.
                </p>
                <p>
                  Kenneth's academic journey also encompasses a Master's degree
                  in Chemistry obtained from Makerere University, complemented
                  by a Bachelor's degree in Science with Education, earned from
                  Mbarara University of Science and Technology. His commitment
                  to education extends to his role as a educator within the
                  Department of Chemistry at Makerere University. Beyond
                  academia, Kenneth's career path has included teaching
                  Chemistry at the secondary school level, demonstrating his
                  dedication to fostering scientific knowledge at different
                  educational stages.
                </p>
                <p>
                  His research pursuits are diverse and encompass the
                  examination of the prevalence and fate of organic chemical
                  contaminants in tropical environments, the intricate interplay
                  between climate change and environmental chemical pollution,
                  as well as the emergence of chemical contaminants in
                  ecosystems and their impacts on both wildlife and human
                  health.
                </p>
                <p>
                  Kenneth's affiliations extend beyond Makerere University and
                  CIRCODU. He has held the prestigious position of a Humboldtian
                  – Georg Forster Fellow, conferred upon him by the Alexander
                  von Humboldt Foundation. During his tenure in this role, he
                  contributed to the Analytical Chemistry department at the
                  Helmholtz Centre for Environmental Research – UFZ in Leipzig,
                  Germany, from May 2017 to April 2020. His areas of interest
                  expand further into environmental risk and impact assessment,
                  agriculture, food safety, and water and sanitation.
                </p>
                <p>
                  Kenneth has a distinguished record of service, having
                  previously served as a Program Coordinator on the Africa
                  Executive Committee for the World Academy (now Association) of
                  Young Scientists (WAYS). He is also an active member of
                  several professional organizations, including the Society of
                  Environmental Toxicology and Chemistry (SETAC), the Royal
                  Society of Chemistry (RSC), the American Chemical Society
                  (ACS), and the Pan African Chemistry Network (PACN). His
                  extensive expertise and multifaceted interests underscore his
                  significant contributions to the field of Environmental
                  Analytical Chemistry and its various intersections.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://ug.linkedin.com/in/kennetharinaitwe"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/CIRCODU1"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/Circodu/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256772858394"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:kenneth.arinaitwe@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default KennethArinaitwe;
